/** Resolve Partner Portal sticky H1 from the current route. */

const PARTNER_PAGE_TITLES = [
  { match: (p) => p === '/partner' || p === '/partner/', title: 'Dashboard' },
  { prefix: '/partner/passbook', title: 'Commission Passbook' },
  { prefix: '/partner/calculator', title: 'Payout Rate Card' },
  { prefix: '/partner/profile', title: 'My Profile' },
  { prefix: '/partner/visiting-card', title: 'Visiting Card' },
  { prefix: '/partner/notifications', title: 'Notifications' },
  { prefix: '/partner/leads', title: 'My Leads' },
];

export function getPartnerPageTitle(pathname) {
  const path = pathname || '';
  for (const entry of PARTNER_PAGE_TITLES) {
    if (entry.match && entry.match(path)) return entry.title;
    if (entry.prefix && path.startsWith(entry.prefix)) return entry.title;
  }
  return 'Partner Portal';
}
